import React from "react";
import Alert from "@carrier-io/air-react/Alert";
import AlertTitle from "@carrier-io/air-react/AlertTitle";
import { AlertProps } from "../types";

export const SuccessAlert = ({ message, onClose }: AlertProps) => {
  return (
    <Alert
      data-testid="success-alert"
      closeText="Close"
      onClose={onClose}
      role="alert"
      color="success"
      severity="success"
      variant="standard"
    >
      <AlertTitle>Success</AlertTitle>
      {message}
    </Alert>
  );
};
